import Datepicker from 'vanillajs-datepicker/Datepicker';

export default function initDatepicker() {
  const elem = document.getElementById('datepicker');
  if (!elem) return;
  
  const datepicker = new Datepicker(elem, {
    orientation: 'bottom',
    minDate: 0,
    autohide: true,
    weekDays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    weekStart: 0,
    showDaysOfWeek: true
  });
  
  // Store reference to datepicker instance for access from other components
  elem._datepicker = datepicker;
  
  // Add event listener for date changes to trigger filtering if needed
  elem.addEventListener('changeDate', function(e) {
    // Trigger the filter click event to update results when date is selected
    const filterEvent = new Event('click', { bubbles: true });
    
    // Wait a moment for the datepicker to process, then trigger filtering
    setTimeout(() => {
      const modalFooterButton = document.querySelector('.modal-footer button');
      if (modalFooterButton) {
        modalFooterButton.dispatchEvent(filterEvent);
      }
    }, 100);
  });
}
